module.exports = __webpack_public_path__ + "img/HtadminImage.4c645609.svg";